/** Asset module constants — statuses, conditions, ops, reports, imports. */

export const ASSET_STATUSES = [
  { id: "available", label: "Available" },
  { id: "assigned", label: "Assigned" },
  { id: "reserved", label: "Reserved" },
  { id: "under_maintenance", label: "Under Maintenance" },
  { id: "damaged", label: "Damaged" },
  { id: "lost", label: "Lost" },
  { id: "scrapped", label: "Scrapped" },
  { id: "disposed", label: "Disposed" },
];

export const ASSET_CONDITIONS = [
  { id: "excellent", label: "Excellent" },
  { id: "good", label: "Good" },
  { id: "fair", label: "Fair" },
  { id: "poor", label: "Poor" },
  { id: "damaged", label: "Damaged" },
];

export const REQUEST_STATUSES = [
  { id: "pending", label: "Pending" },
  { id: "approved", label: "Approved" },
  { id: "rejected", label: "Rejected" },
  { id: "reserved", label: "Reserved" },
  { id: "assigned", label: "Assigned" },
  { id: "cancelled", label: "Cancelled" },
];

export const OPERATION_SUB_TABS = [
  { id: "stock", label: "Stock" },
  { id: "assignment", label: "Assignment" },
  { id: "transfer", label: "Transfer" },
  { id: "return", label: "Return" },
  { id: "maintenance", label: "Maintenance" },
  { id: "verification", label: "Verification" },
  { id: "scrap", label: "Scrap" },
  { id: "recovery", label: "Recovery" },
];

export const SETTINGS_SUB_TABS = [
  { id: "categories", label: "Categories" },
  { id: "types", label: "Types" },
  { id: "numbering", label: "Numbering" },
  { id: "conditions", label: "Conditions / Statuses" },
  { id: "assignment_rules", label: "Assignment rules" },
  { id: "request_workflow", label: "Request workflow" },
  { id: "recovery_rules", label: "Recovery rules" },
  { id: "warranty_amc", label: "Warranty / AMC" },
  { id: "notifications", label: "Notifications" },
];

export const REPORT_KEYS = [
  { id: "register", label: "Asset Register" },
  { id: "employee_wise", label: "Employee-wise Assets" },
  { id: "dept_location", label: "Department / Location" },
  { id: "stock", label: "Stock Summary" },
  { id: "movement", label: "Movement History" },
  { id: "assignment_return", label: "Assignment & Return" },
  { id: "maintenance", label: "Maintenance" },
  { id: "warranty_expiry", label: "Warranty Expiry" },
  { id: "scrap", label: "Scrap / Disposal" },
  { id: "fnf_recovery", label: "F&F Recovery" },
  { id: "pending_requests", label: "Pending Requests" },
  { id: "verification", label: "Verification" },
];

export const IMPORT_EXPORT_KEYS = [
  { id: "asset_master", label: "Asset Master" },
  { id: "opening_stock", label: "Opening Stock" },
  { id: "asset_register", label: "Asset Register" },
  { id: "assignments", label: "Assignments" },
  { id: "stock_transactions", label: "Stock Transactions" },
  { id: "asset_adjustments", label: "Asset Adjustments" },
];

export const DEFAULT_TYPE_LABELS = [
  { id: "laptop", label: "Laptop" },
  { id: "desktop", label: "Desktop" },
  { id: "monitor", label: "Monitor" },
  { id: "phone", label: "Phone" },
  { id: "tablet", label: "Tablet" },
  { id: "vehicle", label: "Vehicle" },
  { id: "furniture", label: "Furniture" },
  { id: "accessory", label: "Accessory" },
  { id: "other", label: "Other" },
];

export const DASHBOARD_KPI_DEFS = [
  { key: "total", label: "Total", tab: "register", filters: {} },
  { key: "available", label: "Available Stock", tab: "register", filters: { status: "available" } },
  { key: "assigned", label: "Assigned", tab: "register", filters: { status: "assigned" } },
  { key: "reserved", label: "Reserved", tab: "register", filters: { status: "reserved" } },
  {
    key: "under_maintenance",
    label: "Under Maintenance",
    tab: "operations",
    filters: { sub: "maintenance" },
  },
  {
    key: "damaged_lost",
    label: "Damaged / Lost",
    tab: "register",
    filters: { status: "damaged" },
  },
  { key: "pending_requests", label: "Pending Requests", tab: "requests", filters: { status: "pending" } },
  { key: "pending_returns", label: "Pending Returns", tab: "operations", filters: { sub: "return" } },
  { key: "pending_recovery", label: "Pending Recovery", tab: "operations", filters: { sub: "recovery" } },
  {
    key: "warranty_expiring",
    label: "Warranty Expiring",
    tab: "reports",
    filters: { report: "warranty_expiry" },
  },
];

/** Primary aside tabs only — hubs are deep-linked, not listed here. */
export const PRIMARY_ASSET_TABS = [
  { id: "dashboard", label: "Dashboard", screen: "asset_dashboard" },
  { id: "register", label: "Asset Register", screen: "asset_list" },
  { id: "requests", label: "Requests", screen: "asset_requests" },
  { id: "operations", label: "Operations", screen: "asset_operations" },
];

export const HUB_ASSET_TABS = [
  { id: "settings", label: "Settings", screen: "asset_settings" },
  { id: "import", label: "Import", screen: "asset_import" },
  { id: "export", label: "Export", screen: "asset_import" },
  { id: "reports", label: "Reports", screen: "asset_reports" },
];

export const ALL_ASSET_TABS = [...PRIMARY_ASSET_TABS, ...HUB_ASSET_TABS];

export const inputSm =
  "w-full rounded-md border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-2 py-1.5 text-sm text-[hsl(var(--ds-fg))] outline-none focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]";

export const fieldLabel =
  "mb-1 text-xs font-semibold uppercase tracking-wide text-[hsl(var(--ds-muted-fg))]";

export function statusLabel(id) {
  return ASSET_STATUSES.find((s) => s.id === id)?.label || id || "—";
}

export function conditionLabel(id) {
  return ASSET_CONDITIONS.find((c) => c.id === id)?.label || id || "—";
}
